import React, { useState } from "react";
import Chart from "react-apexcharts";

const HorizontalChartPreview = ({
                                    color,
                                    colorSecondary,
                                    fontFamily = "Arial, sans-serif",
                                    fontSize = "14px", // Agregamos fontSize como prop
                                    height = 500,
                                    series=[],
                                    values=[],
                                    legendPosition = "top"
                                }) => {

    function getData(){
        // Si son strings, los convierto a arrays
        if (typeof series === "string") {
            series = series.split(",");
        }
        if (typeof values === "string") {
            values = values.split(",");
        }

        return series.reduce((acc, name, index) => {
            acc[name.trim()] = values[index]; // trim() limpia espacios
            return acc;
        }, {});

    }


    const data = getData();

    // Extraer y ordenar datos
    const sortedCountries = Object.entries(data)
        .sort(([, sizeA], [, sizeB]) => sizeB - sizeA)
        .reduce(
            (acc, [country, size]) => {
                acc.labels.push(country);
                acc.values.push(size);
                return acc;
            },
            { labels: [], values: [] }
        );

    const [chartData] = useState({
        series: [
            {
                name: "Usuarios Registrados:",
                data: sortedCountries.values,
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: "100%",
            },
            colors: ["#" + color.replace("#", ""), "#" + colorSecondary.replace("#", "")],
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: "96%",
                },
            },
            dataLabels: {
                enabled: true, // Mantener los valores dentro de las barras
                formatter: (val) => {
                    return Number(val).toLocaleString("es-ES");
                },
                style: {
                    fontFamily,
                },
            },
            xaxis: {
                categories: sortedCountries.labels,
                labels: {
                    show: false, // Ocultar las etiquetas en el eje X (valores abajo)
                },
                axisTicks: {
                    show: false, // Desactivar las marcas del eje X
                },
                axisBorder: {
                    show: false, // Desactivar el borde del eje X
                },
                lines: {
                    show: false, // Desactivar las líneas en el fondo del gráfico
                },
            },
            yaxis: {
                categories: sortedCountries.labels, // Mostrar los nombres de los países en el eje Y
                labels: {
                    style: {
                        fontSize: fontSize, // Tamaño de fuente configurable
                        fontFamily: fontFamily, // Fuente configurable
                    },
                },
            },
            grid: {
                show: false, // Desactivar la grilla
            },
            tooltip: {
                y: {
                    formatter: (val) => {
                        return Number(val).toLocaleString("es-ES");
                    },
                },
            },
            title: {
                text: "",
                align: "center",
                style: {
                    fontSize: "20px",
                    fontFamily,
                },
            },
            legend: {
                show: legendPosition !== "none",
                position: legendPosition === "none" ? "top" : legendPosition,
            },
        },
    });

    return (
        <div style={{ height, display: "flex", flexDirection: "row" }}>
            {/* Contenedor para el gráfico */}
            <div style={{ flex: 1 }}>
                <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="bar"
                    height={height}
                    width="100%"
                />
            </div>
        </div>
    );
};

export default HorizontalChartPreview;
